import { Block, useStyletron } from "@mezo-org/mezo-clay"

import {
  DASHBOARD_HEADER_HEIGHT,
  IS_MEZO_MAINNET,
  MAINNET_BANNER_HEIGHT,
  SIDEBAR_NAVIGATION_WIDTH,
} from "#/shared/constants"

import SidebarNavigationHelp from "./SidebarNavigationHelp"
import SidebarNavigationItemList from "./SidebarNavigationItemList"
import SidebarNavigationMezoChainInfo from "./SidebarNavigationMezoChainInfo"

export default function SidebarNavigation() {
  const [css, theme] = useStyletron()

  return (
    <Block
      padding="20px 0 32px"
      top={`${DASHBOARD_HEADER_HEIGHT}px`}
      width={SIDEBAR_NAVIGATION_WIDTH}
      position="sticky"
      backgroundColor="white"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      maxHeight={
        IS_MEZO_MAINNET
          ? `calc(100vh - ${DASHBOARD_HEADER_HEIGHT}px)`
          : `calc(100vh - ${MAINNET_BANNER_HEIGHT + DASHBOARD_HEADER_HEIGHT}px)`
      }
      className={css({
        borderRight: `1px solid ${theme.colors.borderOpaque}`,
        zIndex: 3,
      })}
    >
      <Block marginBottom="40px">
        <SidebarNavigationItemList />
      </Block>
      <Block padding="0 14px">
        <SidebarNavigationMezoChainInfo />
        <SidebarNavigationHelp />
      </Block>
    </Block>
  )
}
